import { fetcher } from '@commenda/utils';

export async function deletePlan({
  companyId,
  subscriptionId,
  productId,
}: {
  companyId: number;
  subscriptionId: string;
  productId: string;
}) {
  const response = await fetcher(
    `billing-new/plan?companyId=${companyId}&subscriptionId=${subscriptionId}&productId=${productId}`,
    { method: 'DELETE' }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.message || `HTTP ${response.status}: ${response.statusText}`
    );
  }

  return response.json().catch(() => ({}));
}
